module.exports = {"623022100":"柳林镇","623022101":"木耳镇","623022102":"扎古录镇","623022103":"喀尔钦镇","623022104":"藏巴哇镇","623022105":"纳浪镇","623022106":"洮砚镇","623022107":"阿子滩镇","623022108":"申藏镇","623022109":"完冒镇","623022110":"尼巴镇","623022202":"刀告乡","623022207":"恰盖乡","623022208":"康多乡","623022209":"勺哇土族乡","623022400":"卓尼县林场","623022401":"国营大峪牧场","623022402":"国营柏林牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623022.json
// module id = 2973
// module chunks = 0